export default "__VITE_ASSET__63f6e5cd__"